import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { useToast } from "../../Hooks/useToast";

import Box from "@mui/material/Box";

import AlternativeHeader from "../../Components/Headres/Alternative_Header";
import ReservationsCard from "../../Components/Cards/Reservations_Card";
import NotesModal from "./Add_Notes_Modal";

import { fetchGetAllReservationsByIdApi } from "../../Redux/Reservations_Slice";
import { Updatereservation } from "../../Apis/Reservations/Reservations";

const ViewReservations = () => {
  const param = useParams();
  const dispatch = useDispatch();
  const data = useSelector((state) => state.Reservations);
  const navigate = useNavigate();
  const { toastSuccess, toastError } = useToast();
  const [modalOpen, setModalOpen] = useState(false);
  const [adminNote, setAdminNote] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (param.id) {
      dispatch(fetchGetAllReservationsByIdApi(param.id));
    }
  }, [param.id]);

  useEffect(() => {
    const note = data.data?.data?.adminNote || "";
    setAdminNote(note);
  }, [data.data]);

  const handleSaveNotes = async () => {
    setIsLoading(true);
    try {
      const response = await Updatereservation(param.id, { adminNote });
      if (response.status === 200) {
        toastSuccess("Der Vorgang war erfolgreich!");
        dispatch(fetchGetAllReservationsByIdApi(param.id));
        setModalOpen(false);
      } else {
        toastError("Der Vorgang ist fehlgeschlagen!");
      }
    } catch (error) {
      toastError("Ein Fehler ist aufgetreten!");
    } finally {
      setIsLoading(false);
    }
  };

  const getGermanStatus = (status) => {
    switch (status) {
      case "accepted":
        return { label: "Angenommen", color: "#B6E6C1" };
      case "rejected":
        return { label: "Abgelehnt", color: "#E6B6B6" };
      case "pending":
        return { label: "Ausstehend", color: "#F0E0C0" };
      default:
        return { label: "Unbekannt", color: "#CCCCCC" };
    }
  };

  const germanStatus = getGermanStatus(data?.data?.data?.status);

  return (
    <Box>
      <AlternativeHeader
        onPrevious={() => navigate("/")}
        title="Einzelheiten"
      />
      
      {data?.data?.data && (
        <ReservationsCard
          reservationNumber={data?.data?.data?.reservationNumber}
          dateOfReservation={(() => {
            const date = new Date(data?.data?.data?.dateOfReservation);
            const day = String(date.getUTCDate()).padStart(2, '0');
            const month = String(date.getUTCMonth() + 1).padStart(2, '0');
            const year = date.getUTCFullYear();
            const hours = String(date.getUTCHours()).padStart(2, '0');
            const minutes = String(date.getUTCMinutes()).padStart(2, '0');
            return `${hours}:${minutes} ${day}.${month}.${year}`;
          })()}
          firstName={data?.data?.data?.userId?.firstName}
          lastName={data?.data?.data?.userId?.lastName}
          email={data.data.data.userId.email}
          paymentDate={(() => {
            const date = new Date(data.data.data.dateEndOfReservation);
            const day = String(date.getUTCDate()).padStart(2, '0');
            const month = String(date.getUTCMonth() + 1).padStart(2, '0');
            const year = date.getUTCFullYear();
            const hours = String(date.getUTCHours()).padStart(2, '0');
            const minutes = String(date.getUTCMinutes()).padStart(2, '0');
            return `${hours}:${minutes} ${day}.${month}.${year}`;
          })()}
          status={germanStatus.label}
          statusColor={germanStatus.color}
          payWay={data?.data?.data?.payWay}
          note={data?.data?.data?.note}
          adminNote={data?.adminNote}
          name={data?.data?.data?.packageId.name}
          numberOfPersons={data?.data?.data?.numberOfPersons}
          extraObjectsList={data?.data?.data?.extraObjectsList}
          totalPackagePrice={data?.data?.data?.totalPackagePrice}
          totalExtraObjectsPrice={data?.data?.data?.totalExtraObjectsPrice}
          totalPrice={data?.data?.data?.totalPrice}
          onClick={() => setModalOpen(true)}
        />
      )}
      <NotesModal
        open={modalOpen}
        handleClose={() => setModalOpen(false)}
        notes={adminNote}
        setNotes={setAdminNote}
        handleSave={handleSaveNotes}
        loading={isLoading}
      />
    </Box>
  );
};

export default ViewReservations;